<template>
  <div class="cursorUp" :class="{ cursorUpOn: isCursorUpOn }">
    <a href="javascript:void(0);" @click="moveUp">
      <img src="/img2022/bt_pageTop.png" srcset="/img2022/bt_pageTop@2x.png 2x" alt="ページトップに移動">
    </a>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      isCursorUpOn: false
    }
  },
  mounted () {
    // スクロールイベント設定
    // window.addEventListener('scroll', this.scrollHandler)
  },
  methods: {
    moveUp () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.cursorUp {
  width: 68px;
  height: 58px;
  opacity: 0.8;
  transition: all 0.3s;
  visibility: visible;
}

.cursorUpOn {
  opacity: 0.8;
  transition: all 0.3s;
  visibility: visible;
}

.cursorUp a:hover,
.cursorUp a:hover img {
  opacity: 0.8;  
}

.cursorUp img {
  width: 68px;
  height: 58px;
  object-fit: contain;
}

@media screen and ( max-width:640px) {
  .cursorUp {
    width: calc((100vw - 16px) * (68 / 494));
    height: calc((calc((100vw - 16px) * (68 / 494)) / 68 * 58));
  }

  .cursorUp img {
    width: calc((100vw - 16px) * (68 / 494));
    height: calc((calc((100vw - 16px) * (68 / 494)) / 68 * 58));
  }
}
</style>
